import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import dataicon from "../assets/svgs/whitedataicon.svg";
import buttonarrow from "../assets/svgs/buttonarrow.svg";
import { ReactSVG } from 'react-svg';

const ExtendValidityCarousel = ({ packages, onSubscribe, loading, type = "validity" }) => {
  if (loading) {
    return (
      <div className="animate-pulse flex flex-col justify-center bg-white h-40 rounded-3xl mb-3 space-y-3 p-3">
        <div className="h-6 w-3/4 bg-slate-300 rounded-md mx-auto"></div>
        <div className="h-4 w-1/2 bg-slate-300 rounded-md mx-auto"></div>
        <div className="h-8 w-1/3 bg-slate-300 rounded-md mx-auto mt-4"></div>
      </div>
    );
  }

  if (!packages || packages.length === 0) {
    return null;
  }

  const slidesPerView = type === "validity" ? 1.5 : 1.2;

  return (
    <div className="relative w-full mt-2">
      <Swiper
        loop={packages.length === 2}
        slidesPerView={slidesPerView}
        spaceBetween={15}
        centeredSlides={false}
        initialSlide={0}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        breakpoints={{
          640: {
            slidesPerView,
            spaceBetween: 20,
          },
          768: {
            slidesPerView,
            spaceBetween: 25,
          },
          1024: {
            slidesPerView,
            spaceBetween: 30,
          },
        }}
        className="validity-swiper"
      >
        {packages.map((pkg, index) => {
          const packageName = pkg.packageName || pkg.code || pkg.name || "Package";
          const displayName = pkg.display_name || pkg.name || pkg.code || packageName;
          const price = Number(pkg.price ?? pkg.amount ?? 0).toFixed(2);
          const metadata = type === "data"
            ? pkg.validity || pkg.remarks || "Data Plan"
            : `Extended ${pkg.dataValidity} Days`;
          const description = pkg.additional_data || pkg.remarks || pkg.description || "Choose this package for your next top-up.";
          return (
            <SwiperSlide
              key={`${packageName}-${index}`}
              className=" !h-auto self-stretch"
            >
              <div onClick={() => onSubscribe(packageName, price)} className={`p-3 flex flex-col justify-between h-full w-[98%] rounded-3xl text-white 
              ${index % 2 === 0
                  ? "bg-gradient-to-r from-gradiantprimary to-gradiantsecondary"
                  : "bg-gradient-to-r from-[#9A77ED] to-[#5A468C]"
                }`}>
                <div>
                  <div className="flex gap-[10px] items-center">
                    <ReactSVG src={dataicon} />
                    <div className="flex flex-col">
                      <h3 className="font-semibold text-[17px]">
                        {displayName}
                      </h3>
                      <span className="text-[13px] text-[#FFFFFF7A]">
                        {metadata}
                      </span>
                    </div>
                  </div>
                  <div className="mt-3">
                    {
                      type === "data" && (
                        <p className="text-[13px] text-[#FFFFFF7A]">
                          Details
                        </p>
                      )
                    }
                    <span className={`${type==="data" ? "text-[14px] font-semibold" : "text-[13px]"}`}>
                      {description}
                    </span>
                  </div>
                </div>
                <div className="w-full flex justify-between items-center mt-3">
                  <h1 className='text-[17px] font-semibold'>
                    RM {price}
                  </h1>
                  <button
                    // onClick={() => onSubscribe(packageName, price)}
                    className="bg-primary/10 w-[36px] h-[36px] rounded-full flex justify-center items-center"
                  >
                    <ReactSVG src={buttonarrow} />
                  </button>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default ExtendValidityCarousel;